import { render, staticRenderFns } from "./ClusterVsBoxReport.vue?vue&type=template&id=16938762"
import script from "./ClusterVsBoxReport.vue?vue&type=script&lang=js"
export * from "./ClusterVsBoxReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports